





















import { anyToDate, differenceInMilliseconds } from 'vtils/date'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { getServerDate } from '@/utils'

export default defineClassComponent<{
  /** 倒计时毫秒 */
  duration?: number
  /** 倒计时日期 */
  date?: any
  /** 格式化 */
  format?: string
  /** 格式化到天，默认是时 */
  formatToDay?: boolean
}>(
  {
    props: ['duration', 'date', 'format', 'formatToDay'],
  },
  ({ props }) =>
    class {
      pad = (v: number) => (v < 10 ? `0${v}` : `${v}`)

      countdownDuration = computed(() => {
        return props.duration != null
          ? props.duration
          : Math.abs(
              differenceInMilliseconds(
                getServerDate(),
                anyToDate(props.date),
              ),
            )
      })
    },
)
